



 import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
 import AgroGenericCard from "@/components/agroGenericCard/AgroGenericCard.vue";
 import * as farmsApi from "@/api/farms";
 import { FarmCount } from "@/api/farms/types";

 @Component({
   name: 'CardFarmsCountController',
   components: {
     AgroGenericCard,
   }
 })

export default class CardFarmsCountController extends Vue {
  private isLoading = false;
  private count: number | null = null;

  @Prop({ type: Boolean, default: false }) private onlyUserFarms!: boolean;
  @Prop({ type: Boolean, default: false }) private onlyActiveMonitoring!: boolean;
  @Prop({ type: Boolean, default: false }) private isAddNewFarm!: boolean;
  @Prop({ type: Boolean, default: false }) private isRemovedFarm!: boolean;

  async mounted() {
    await this.getCountFarm();
  };

  @Watch('onlyUserFarms')
  @Watch('onlyActiveMonitoring')
  @Watch('isAddNewFarm')
  @Watch('isRemovedFarm')
  private async getCountFarm() {
    this.isLoading = true;
    try {
      const response = (await farmsApi.getCountFarms(this.onlyUserFarms, this.onlyActiveMonitoring)).data;
      this.count = response.value;
    } catch {
      this.count = null;
    } finally {
      this.isLoading = false;
    }
  }
  
}
